import React, { useState, useEffect, useCallback, useRef } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { getUserCurrentPlanDetail } from "../utils/customerApi";
import "../assets/css/check-current-plan.css";

const CheckCurrentPlan = ({ app_type, app_name, app_slug, from_page, children }) => {
    const navigate = useNavigate();
    const [isDisabled, setIsDisabled] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [planDetails, setPlanDetails] = useState(null);
    const hasFetched = useRef(false);

    const fetchCurrentPlanData = useCallback(async () => {
        if (hasFetched.current) return; 
        hasFetched.current = true; 

        try { 
            const result = await getUserCurrentPlanDetail(app_type);
            if (result?.status === true) {
                setPlanDetails(result.data);

                if (result?.status === true && result.data.current_created_app_count >= result.data.plan_widgets_count) {
                    setIsDisabled(true);
                    if (from_page) {
                        toast.error("Widget limit exceeded. Please Increase Widget Limit...");
                        navigate(`/customer/apps/${app_slug}/pricing/single`);
                    }
                }
            }
        } catch (error) {
            toast.error(`${error.message}`);
        } 
    }, [app_type, app_slug, from_page, navigate]);

    useEffect(() => {
        fetchCurrentPlanData();
    }, [fetchCurrentPlanData]);

    const handleClick = (event) => {
        if (isDisabled && !from_page) {
            event.preventDefault();
            setPopupOpen(true);
        }
    };

    return (
        <>
            {/* Conditionally clone children and apply the onClick handler */}
            {children && React.cloneElement(children, { onClick: handleClick })}

            {/* Popup Modal - Only shows if from_page=false and limit is reached */}
            {isPopupOpen && (
                <div className="popup-overlay widget-plans">
                    <div className="popup-content">
                        <h2>{app_name} Widget Limit Reached</h2>
                        <p>
                            You can create only <strong>{planDetails?.plan_widgets_count || 0}</strong> {app_name} widgets on the <strong>{planDetails?.plan_name || "Free"}</strong> plan.
                            Upgrade your plan to increase the limit or delete an existing widget.
                        </p>
                        <Link to={`/customer/apps/${app_slug}/pricing/single`} className="upgrade-button">
                            Increase Widget Limit
                        </Link>
                        <button className="close-popup" onClick={() => setPopupOpen(false)}><img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="ceta-icon" /> </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default CheckCurrentPlan;
